import Vue from 'vue'
import Router from 'vue-router'
import { DocumentSettingsService } from '@/services/documentSettingsService'
import { documentMenuAllowed } from '@/helpers/documentDisplay'
import { EventBus } from '@/event-bus'
import OrderTable from '../views/Orders/OrdersTable.vue'
import { SEGMENTS } from '../constants/segments'
// import OrderList from '../views/Orders/OrdersList.vue'
import AdditionalServices from 'additional-services'
import InventoryBO from 'reception-front'
import TemplatesManagerBO from 'template-manager-front'
import LookbookManager from 'lookbook-manager-front'
import ParsingsHistoryBO from 'parsings-history-front'
import UnifiedStock from 'unified-stock-front'
import store from '../store/index'
import Callback from '../views/Callback.vue'
import { ReturnSettingsService } from '../services/returnSettingsService'

import CarriersDetails from '../views/Carriers/CarriersDetails.vue'
import CarriersTable from '../views/Carriers/CarriersTable.vue'
import DeliveryDetails from '../views/Carriers/DeliveryDetails.vue'
import DeliveryTable from '../views/Carriers/DeliveryTable.vue'

import AppointmentServiceDetails from '../views/InStoreAppointments/InStoreAppointmentServiceDetails.vue'
import AppointmentServicesTable from '../views/InStoreAppointments/InStoreAppointmentServicesTable'
import AppointmentsTable from '../views/InStoreAppointments/InStoreAppointmentsTable'
import AppointmentsTableDetails from '../views/InStoreAppointments/InStoreAppointmentsTableDetails'

import LocationDetails from '../views/Locations/LocationDetail.vue'
import LocationsTable from '../views/Locations/LocationsTable.vue'
import locationsSettings from '@/views/Locations/LocationsSettings.vue'

import OrderWorkflows from '../views/OrderWorkflows/OrderWorkflowsDetails.vue'
import OrderWorkflowsTable from '../views/OrderWorkflows/OrderWorkflowsTable.vue'
import OrderDetails from '../views/Orders/OrderDetails.vue'
import OrderDetailsSeller from '../views/Orders/OrderDetailsSeller.vue'
import OrdersSettings from '../views/Orders/OrdersSettings'
import OrdersSettingsTable from '../views/Orders/OrdersSettingsTable'
import OrdersTableAdmin from '../views/Orders/OrdersTableAdmin'
import GlobalSearchOrder from '@/views/Orders/GlobalSearchOrder.vue'
import DocumentsTable from '@/views/Documents/DocumentsTable.vue'
import DocumentSettings from '@/views/Documents/DocumentSettings.vue'

import PartnersTable from '../views/Partners/PartnersTable'
import PartnerDetails from '../views/Partners/PartnerDetails.vue'

import ReturnCreate from '../views/Returns/ReturnCreate.vue'
import ReturnDetails from '../views/Returns/ReturnDetail.vue'
import ReturnSearchOrder from '../views/Returns/ReturnSearchOrder.vue'
import ReturnTable from '../views/Returns/ReturnTable.vue'
import RefundTable from '../views/Refunds/RefundTable.vue'
import RefundDetail from '../views/Refunds/RefundDetail.vue'
import ProductsSettings from '../views/Settings/ProductsSettings'
import ServicesSettings from '../views/Settings/ServicesSettings'

import SubOrderDetails from '../views/SubOrders/SubOrderDetails'
import SubOrdersTable from '../views/SubOrders/SubOrdersTable'
import SubOrdersTableAdmin from '../views/SubOrders/SubOrdersTableAdmin'

import UserCreate from '../views/Users/UserCreate.vue'
import UsersTable from '../views/Users/UsersTable.vue'
import Dashboard from '../views/dashboard/Dashboard'
import TasksManagement from 'tasks-manager-front'
import ConfigurationManager from 'configuration-manager-front'

import Index from '@/views/Index'
import ReturnSettingsDetails from '../views/Returns/ReturnSettingsDetails.vue'
import ReturnSettingsTable from '../views/Returns/ReturnsSettingsTable.vue'

import EbookingsCustomization from '../views/Customization/Ebookings/EbookingsCustomization.vue'
import EbookingsCustomizationsTable from '../views/Customization/Ebookings/EbookingsCustomizationsTable.vue'

import TriggerDetail from '../views/Triggers/TriggerDetail.vue'
import TriggerSettings from '../views/Triggers/TriggerSettings.vue'
import TriggersTable from '../views/Triggers/TriggersTable.vue'
import TriggerHistoryDetails from '../views/TriggersHistories/TriggerHistoryDetails.vue'
import TriggersHistoriesTable from '../views/TriggersHistories/TriggersHistoriesTable.vue'

import FindInStoreSettings from '../views/FindInStore/FindInStoreSettings.vue'
import FindInStoreSettingsTable from '../views/FindInStore/FindInStoreSettingsTable.vue'

import Errors from '../views/Errors'

import listsTable from '../views/Lists/ListsTable.vue'
import listDetails from '../views/Lists/ListDetail.vue'

import BinSummary from '../views/SubOrders/BinSummary'
import PickPackShipsTable from '../views/SubOrders/PickPackShipsTable'

Vue.use(Router)

const router = new Router({
  routes: [
    // disabled for debug
    {
      path: '/',
      // redirect: 'orders',
      component: Index,
      children: [
        {
          path: '',
          redirect: 'orders',
        },
        {
          name: 'partners',
          path: 'partners',
          component: PartnersTable,
          meta: {
            requiresAuth: true,
            accessRight: 'isOctipasAdmin',
            breadcrumbs: {
              label: 'partners',
              reset: true,
            },
          },
        },
        {
          name: 'partnerDetails',
          path: 'partners/:id',
          component: PartnerDetails,
          meta: {
            requiresAuth: true,
            accessRight: 'isOctipasAdmin',
            breadcrumbs: {
              label: 'partners',
              reset: true,
            },
          },
        },
        {
          name: 'orders',
          path: 'orders',
          component: OrdersTableAdmin,
          meta: {
            requiresAuth: true,
            accessRight: 'isCustomerService',
            breadcrumbs: {
              label: 'orders',
              reset: true,
            },
          },
        },
        {
          name: 'documentSettings',
          path: 'document-settings',
          component: DocumentSettings,
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'documentSettings',
              reset: true,
            },
          },
        },
        {
          name: 'documents',
          path: 'documents',
          component: DocumentsTable,
          beforeEnter: documentMenuGuard,
          meta: {
            requiresAuth: true,
            // No parent: the list is not limited to order documents, and /orders is out of reach
            // for a store user anyway.
            breadcrumbs: {
              label: 'documents',
              reset: true,
            },
          },
        },
        {
          name: 'subOrdersList',
          path: 'sub-orders',
          component: SubOrdersTableAdmin,
          meta: {
            requiresAuth: true,
            accessRight: 'isCustomerService',
            breadcrumbs: {
              label: 'subOrdersList',
              reset: true,
            },
          },
        },
        {
          name: 'nonCompliantOrders',
          path: 'orders/non-compliant',
          props: { ...SEGMENTS.orders.non_compliant },
          component: OrdersTableAdmin,
          meta: {
            requiresAuth: true,
            accessRight: 'isCustomerService',
            breadcrumbs: {
              label: 'nonCompliantOrders',
              reset: true,
            },
          },
        },
        {
          name: 'waitingAllocationOrders',
          path: 'sub-orders/waiting-allocation',
          props: { ...SEGMENTS.subOrders.waiting_allocation },
          component: SubOrdersTableAdmin,
          meta: {
            requiresAuth: true,
            accessRight: 'isCustomerService',
            breadcrumbs: {
              label: 'waitingAllocationOrders',
              reset: true,
            },
          },
        },
        {
          name: 'errorOrders',
          path: 'orders/errors',
          props: { ...SEGMENTS.orders.error },
          component: OrdersTableAdmin,
          meta: {
            requiresAuth: true,
            accessRight: 'isCustomerService',
            breadcrumbs: {
              label: 'errorOrders',
              reset: true,
            },
          },
        },
        {
          name: 'waitingOrders',
          path: 'sub-orders/waiting',
          props: { ...SEGMENTS.subOrders.waiting },
          component: SubOrdersTable,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'waitingOrders',
              reset: true,
            },
          },
        },
        {
          name: 'confirmedOrders',
          path: 'sub-orders/confirmed',
          props: { ...SEGMENTS.subOrders.confirmed },
          component: SubOrdersTable,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'confirmedOrders',
              reset: true,
            },
          },
        },
        {
          name: 'waitingParcelReceiptOrders',
          path: 'sub-orders/waiting-parcel-receipt',
          props: { ...SEGMENTS.subOrders.waiting_parcel_receipt },
          component: SubOrdersTable,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'waitingParcelReceiptOrders',
              reset: true,
            },
          },
        },
        {
          name: 'notAllocatedOrders',
          path: 'sub-orders/not-allocated',
          props: { ...SEGMENTS.subOrders.waiting_allocation },
          component: SubOrdersTable,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'notAllocatedOrders',
              reset: true,
            },
          },
        },
        {
          name: 'waitingCustomerOrders',
          path: 'orders/waiting-customer',
          props: { ...SEGMENTS.orders.waiting_customer, restrictToCurrentStore: true },
          component: OrderTable,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'waitingCustomerOrders',
              reset: true,
            },
          },
        },
        {
          name: 'waitingPaymentOrders',
          path: 'orders/waiting-payment',
          props: { ...SEGMENTS.orders.waiting_payment, restrictToCurrentStore: true },
          component: OrderTable,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'waitingPaymentOrders',
              reset: true,
            },
          },
        },
        {
          name: 'OrdersWaitingPickupCarrier',
          path: 'sub-orders/waiting-carrier',
          props: { ...SEGMENTS.subOrders.waiting_carrier },
          component: SubOrdersTable,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'OrdersWaitingPickupCarrier',
              reset: true,
            },
          },
        },
        {
          name: 'preparationHistory',
          path: 'sub-orders/preparation-history',
          props: { ...SEGMENTS.subOrders.preparation_history },
          component: SubOrdersTable,
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'ordersHistory',
          path: 'orders/history',
          props: {
            segment: 'store_orders',
            restrictToCurrentStore: true,
          },
          component: OrderTable,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'storeOrders',
              reset: true,
            },
          },
        },
        {
          name: 'toPutBackInStock',
          path: 'sub-orders/to-put-back-in-stock',
          component: SubOrdersTable,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'toPutBackInStock',
              reset: true,
            },
          },
        },
        {
          name: 'subOrderDetails',
          path: 'sub-orders/:id',
          component: SubOrderDetails,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'subOrderDetails',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'subOrdersList',
                to: '/sub-orders',
              },
            ],
          },
        },
        {
          name: 'appointments',
          path: 'appointments/:type',
          component: AppointmentsTable,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'appointments',
              reset: true,
            },
          },
        },
        {
          name: 'appointmentsDetails',
          path: 'appointments/:id',
          component: AppointmentsTableDetails,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'appointmentsDetails',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'appointments',
                to: '/appointments/all',
              },
            ],
          },
        },
        {
          name: 'appointmentServices',
          path: 'appointment-services',
          component: AppointmentServicesTable,
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'appointmentServices',
              reset: true,
            },
          },
        },
        {
          name: 'appointmentServiceDetails',
          component: AppointmentServiceDetails,
          path: 'appointment-services/add',
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'appointmentServiceDetailsCreate',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'appointmentServices',
                to: '/appointment-services',
              },
            ],
          },
          props: true,
        },
        // {
        //     name: "orderList",
        //     path: "ordersbis",
        //     component: OrderList,
        //     meta: { requiresAuth: true },
        // },
        {
          name: 'OrdersSettingsTable',
          component: OrdersSettingsTable,
          path: '/orders-settings',
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'OrdersSettingsTable',
              reset: true,
            },
          },
        },
        {
          name: 'OrdersSetting',
          component: OrdersSettings,
          path: '/orders-settings/:id',
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'OrdersSetting',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'OrdersSettingsTable',
                to: '/orders-settings',
              },
            ],
          },
        },
        {
          name: 'globalSearchOrder',
          path: 'orders/search',
          component: GlobalSearchOrder,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'searchAnOrder',
              reset: true,
            },
          },
        },
        {
          name: 'orderDetails',
          path: 'orders/:id',
          component: OrderDetails,
          meta: {
            requiresAuth: true,
            accessRight: 'isCustomerService',
            breadcrumbs: {
              label: 'orderDetails',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'orders',
                to: '/orders',
              },
            ],
          },
        },
        {
          name: 'orderDetailsSeller',
          path: '/seller-orders/:id',
          component: OrderDetailsSeller,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'orderDetailsSeller',
              reset: false,
            },
          },
        },
        {
          name: 'OrderWorkflowsTable',
          path: '/order-workflows',
          component: OrderWorkflowsTable,
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'workflows',
              reset: true,
            },
          },
        },
        {
          name: 'OrderWorkflowsAdd',
          path: '/order-workflows/add',
          component: OrderWorkflows,
          props: true,
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'addWorkflow',
              reset: true,
            },
            parentBreadcrumbs: [
              {
                label: 'workflows',
                to: '/order-workflows',
              },
            ],
          },
        },
        {
          name: 'OrderWorkflowsDetails',
          path: '/order-workflows/:id',
          component: OrderWorkflows,
          props: true,
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'workflow',
              reset: true,
            },
            parentBreadcrumbs: [
              {
                label: 'workflows',
                to: '/order-workflows',
              },
            ],
          },
        },
        {
          name: 'locations',
          component: LocationsTable,
          path: 'locations',
          meta: {
            requiresAuth: true,
            accessRight: 'isCustomerService',
            breadcrumbs: {
              label: 'locations',
              reset: true,
            },
          },
        },
        {
          name: 'locationsSettings',
          component: locationsSettings,
          path: 'locations-settings',
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'locationsSettings',
              reset: true,
            },
          },
        },
        {
          name: 'locationDetails',
          component: LocationDetails,
          path: 'locations/add',
          meta: {
            requiresAuth: true,
            accessRight: 'isCustomerService',
            breadcrumbs: {
              label: 'locationDetails',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'locations',
                to: '/locations',
              },
            ],
          },
        },
        {
          name: 'locationEdit',
          component: LocationDetails,
          path: 'locations/:id',
          meta: {
            requiresAuth: true,
            accessRight: 'isShopManager',
            breadcrumbs: {
              label: 'locationEdit',
              reset: true,
            },
            parentBreadcrumbs: [
              {
                label: 'locations',
                to: '/locations',
              },
            ],
          },
        },
        {
          name: 'users',
          component: UsersTable,
          path: 'users',
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'users',
              reset: true,
            },
          },
        },
        {
          name: 'userCreate',
          component: UserCreate,
          path: 'users/add',
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'userCreate',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'users',
                to: '/users',
              },
            ],
          },
        },
        {
          name: 'userEdit',
          component: UserCreate,
          path: 'users/:id',
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'userEdit',
              reset: true,
            },
          },
          beforeEnter(to, from, next) {
            if (store.state.isAdmin) {
              to.meta.parentBreadcrumbs = [
                {
                  label: 'users',
                  to: '/users',
                },
              ]
            }
            next()
          },
        },
        {
          name: 'ProductsSettings',
          component: ProductsSettings,
          path: 'settings/products',
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'ProductsSettings',
              reset: true,
            },
          },
        },
        {
          name: 'ServicesSettings',
          component: ServicesSettings,
          path: 'settings/services',
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'ServicesSettings',
              reset: true,
            },
          },
        },
        {
          name: 'Dashboard',
          path: 'dashboard',
          component: Dashboard,
          meta: {
            requiresAuth: true,
            accessRight: 'isShopManager',
            breadcrumbs: {
              label: 'Dashboard',
              reset: true,
            },
          },
        },
        {
          name: 'returns',
          path: 'returns',
          component: ReturnTable,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'returns',
              reset: true,
            },
          },
        },
        {
          // Central refunds (admin / customer service): not store-scoped.
          name: 'refunds',
          path: 'refunds',
          component: RefundTable,
          beforeEnter: refundCentralGuard,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'refunds',
              reset: true,
            },
          },
        },
        {
          // Store refunds (seller / shop manager): scoped to the connected store.
          name: 'storeRefunds',
          path: 'my-refunds',
          component: RefundTable,
          beforeEnter: refundFeatureGuard,
          props: { restrictToCurrentStore: true },
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'storeRefunds',
              reset: true,
            },
          },
        },
        {
          // Central refund detail (admin / customer service): parent breadcrumb → central list.
          name: 'refundDetails',
          path: 'refunds/:id',
          component: RefundDetail,
          beforeEnter: refundCentralGuard,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'refundDetails',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'refunds',
                to: '/refunds',
              },
            ],
          },
        },
        {
          // Store refund detail (seller / shop manager): parent breadcrumb → store list, so a
          // store-only user is not sent to the central list (which refundCentralGuard rejects).
          // The context lives in the URL, so this holds on refresh / deep-link too.
          name: 'storeRefundDetails',
          path: 'my-refunds/:id',
          component: RefundDetail,
          beforeEnter: refundFeatureGuard,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'refundDetails',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'storeRefunds',
                to: '/my-refunds',
              },
            ],
          },
        },
        {
          name: 'returnCreate',
          path: 'returns/add',
          beforeEnter: (to, from, next) => {
            if (!to.params.id) {
              next('returnSearchOrder')
            } else {
              next()
            }
          },
          component: ReturnCreate,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'returnCreate',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'returns',
                to: '/returns',
              },
            ],
          },
          props: true,
        },
        {
          name: 'returnSettingsTable',
          path: 'returns-settings',
          component: ReturnSettingsTable,
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'returnSettingsTable',
              reset: true,
            },
          },
        },
        {
          name: 'ReturnSettingsCreate',
          component: ReturnSettingsDetails,
          path: 'returns-settings/add',
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'ReturnSettingsCreate',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'returnSettingsTable',
                to: '/returns-settings',
              },
            ],
          },
        },
        {
          name: 'ReturnSettingsEdit',
          component: ReturnSettingsDetails,
          path: 'returns-settings/:id',
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'ReturnSettingsEdit',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'returnSettingsTable',
                to: '/returns-settings',
              },
            ],
          },
        },
        {
          name: 'returnDetails',
          path: 'returns/:id',
          component: ReturnDetails,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'returnDetails',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'returns',
                to: '/returns',
              },
            ],
          },
        },
        {
          name: 'returnSearchOrder',
          path: 'returnSearchOrder',
          component: ReturnSearchOrder,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'returnSearchOrder',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'returns',
                to: '/returns',
              },
            ],
          },
        },
        {
          name: 'unifiedStockTransfersTable',
          path: 'stocks/transfers',
          component: UnifiedStock.Transfers,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'unifiedStockTransfersTable',
              reset: true,
            },
          },
        },
        {
          name: 'unifiedStockTransfersCreate',
          path: 'stocks/transfers/create',
          component: UnifiedStock.CreateTransfer,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'unifiedStockTransfersCreate',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'unifiedStockTransfersTable',
                to: '/stocks/transfers',
              },
            ],
          },
        },
        {
          name: 'unifiedStockTransfersDetails',
          path: 'stocks/transfers/:id',
          component: UnifiedStock.DetailsTransfers,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'unifiedStockTransfersDetails',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'unifiedStockTransfersTable',
                to: '/stocks/transfers',
              },
            ],
          },
        },
        {
          name: 'unifiedStockTransfersUpdate',
          path: 'stocks/transfers/:id/edit',
          component: UnifiedStock.CreateTransfer,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'unifiedStockTransfersUpdate',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'unifiedStockTransfersTable',
                to: '/stocks/transfers',
              },
            ],
          },
        },
        {
          name: 'unifiedStockTransferTypologiesTable',
          path: 'stocks/transfers-typologies',
          component: UnifiedStock.TransferTypologies,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'unifiedStockTransferTypologiesTable',
              reset: true,
            },
          },
        },
        {
          name: 'unifiedStockTransferTypologiesCreate',
          path: 'stocks/transfers-typologies/create',
          component: UnifiedStock.DetailsTransferTypology,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'unifiedStockTransferTypologiesCreate',
              reset: true,
            },
          },
        },
        {
          name: 'unifiedStockTransferTypologiesDetails',
          path: 'stocks/transfers-typologies/:id',
          component: UnifiedStock.DetailsTransferTypology,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'unifiedStockTransferTypologiesDetails',
              reset: true,
            },
          },
        },
        {
          name: 'unifiedStockTable',
          path: 'stocks/list',
          component: UnifiedStock.Stocks,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'unifiedStockParentTableList',
              reset: true,
            },
          },
        },
        {
          name: 'unifiedStockVariantTable',
          path: 'stocks/products/:id/variants',
          component: UnifiedStock.VariantStocks,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'unifiedStockVariantTable',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'unifiedStockParentTableSearch',
                to: '/stocks/search',
              },
            ],
          },
        },
        {
          name: 'unifiedStockLocationTable',
          path: 'stocks/products/:idVariant/locations',
          component: UnifiedStock.LocationStocks,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'unifiedStockLocationTable',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'unifiedStockParentTableSearch',
                to: '/stocks/search',
              },
              {
                label: 'unifiedStockVariantTable',
                to: '/stocks/products/:idVariant/variants',
              },
            ],
          },
        },
        {
          name: 'unifiedStockDetails',
          path: 'stocks/products/:idVariant/locations/:idLocation',
          component: UnifiedStock.DetailsStocks,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'unifiedStockDetails',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'unifiedStockParentTableSearch',
                to: '/stocks/search',
              },
              {
                label: 'unifiedStockVariantTable',
                to: '/stocks/products/:idVariant/variants',
              },
              {
                label: 'unifiedStockLocationTable',
                to: '/stocks/products/:idVariant/locations',
              },
            ],
          },
        },
        {
          name: 'unifiedStockParsingHistory',
          path: 'stocks/parsing-history',
          component: UnifiedStock.ParsingHistory,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'unifiedStockParsingHistory',
              reset: true,
            },
          },
        },
        {
          name: 'unifiedStockExportHistory',
          path: 'stocks/export-history',
          component: UnifiedStock.ExportHistory,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'unifiedStockExportHistory',
              reset: true,
            },
          },
        },
        {
          name: 'unifiedStockSettings',
          path: 'stocks/global-settings',
          component: UnifiedStock.Settings,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'unifiedStockSettings',
              reset: true,
            },
          },
        },
        {
          name: 'UnifiedStockSettingsTable',
          path: 'stocks/settings',
          component: UnifiedStock.StockSettingsTable,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'UnifiedStockSettingsTable',
              reset: true,
            },
          },
        },
        {
          name: 'templatesManagerTable',
          path: 'templatesmanager/list',
          component: TemplatesManagerBO.TemplateManagerList,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'templatesManagerTable',
              reset: true,
            },
          },
        },
        {
          path: '/templatesManager/:idTemplateManager/:titleTemplateManager',
          name: 'TemplateManagerDetailsTable',
          component: TemplatesManagerBO.TemplateManagerDetailsTable,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: '/templatesManager/:idTemplateManager/:titleTemplateManager/email',
          name: 'TemplateEmailDetails',
          component: TemplatesManagerBO.TemplateEmailDetails,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: '/lookbook-manager',
          name: 'LookbookManager',
          component: LookbookManager,
          props: true,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'lookbook',
              reset: true,
            },
          },
        },
        {
          path: '/parsings',
          name: 'parsingsHistoryTable',
          component: ParsingsHistoryBO.ParsingsHistoryTable,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: '/additionalServices',
          name: 'additionalServicesList',
          component: AdditionalServices.AdditionalServicesList,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: '/additionalService/:idAdditionalService',
          name: 'additionalServicesUpsert',
          component: AdditionalServices.AdditionalServicesUpsert,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: '/tasks',
          name: 'tasksList',
          component: TasksManagement.TaskList,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: '/configurations/general',
          name: 'configurationsGeneral',
          component: ConfigurationManager.ConfigurationGeneral,
          props: true,
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
          },
        },
        {
          path: '/configurations/customer',
          name: 'configurationsCustomer',
          component: ConfigurationManager.ConfigurationCustomer,
          props: true,
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
          },
        },
        {
          path: '/configurations/reachout',
          name: 'configurationsReachout',
          component: ConfigurationManager.Reachouts,
          props: true,
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
          },
        },
        {
          path: '/configurations/catalog',
          name: 'configurationsCatalog',
          component: ConfigurationManager.ConfigurationCatalog,
          props: true,
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
          },
        },
        {
          path: '/configurations/tunnel',
          name: 'configurationsTunnel',
          component: ConfigurationManager.ConfigurationPurchaseTunnel,
          props: true,
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
          },
        },
        {
          path: '/configurations/statistics',
          name: 'configurationsStatistics',
          component: ConfigurationManager.ConfigurationStatistics,
          props: true,
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
          },
        },
        {
          name: 'Reception',
          path: 'reception',
          component: InventoryBO.Reception,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'Reception',
              reset: true,
            },
          },
        },
        {
          name: 'DetailReception',
          path: 'reception/:store/:id',
          component: InventoryBO.DetailReception,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'DetailReception',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'Reception',
                to: '/reception',
              },
            ],
          },
        },
        {
          name: 'Inventory',
          path: 'inventory/list',
          component: InventoryBO.InventoryTable,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'Inventory',
              reset: true,
            },
          },
        },
        {
          name: 'InventoryDetail',
          path: 'inventory/detail/:store_name/:id',
          component: InventoryBO.InventoryDetail,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'InventoryDetail',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'Inventory',
                to: '/inventory/list',
              },
            ],
          },
        },
        {
          name: 'InventoryCreate',
          path: 'inventory/create',
          component: InventoryBO.InventoryCreate,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'InventoryCreate',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'Inventory',
                to: '/inventory/list',
              },
            ],
          },
        },
        {
          name: 'InventoryUpdate',
          path: 'inventory/update/:id',
          component: InventoryBO.InventoryUpdate,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'InventoryUpdate',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'Inventory',
                to: '/inventory/list',
              },
            ],
          },
        },
        {
          name: 'Session',
          path: 'session',
          component: InventoryBO.SessionTable,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'session',
              reset: true,
            },
          },
        },
        {
          name: 'InventoryReturns',
          path: 'inventory-returns',
          component: InventoryBO.InventoryReturns,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'returns',
              reset: true,
            },
          },
        },
        {
          name: 'InventoryReturnCreate',
          path: 'inventory-returns/create',
          component: InventoryBO.InventoryReturnCreate,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'returnCreate',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'returns',
                to: '/inventory-returns',
              },
            ],
          },
        },
        {
          name: 'InventoryReturnDetail',
          path: 'inventory-returns/:id/detail',
          component: InventoryBO.InventoryReturnDetail,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'returnDetails',
              reset: true,
            },
            parentBreadcrumbs: [
              {
                label: 'returns',
                to: '/inventory-returns',
              },
            ],
          },
        },
        {
          name: 'InventoryReturnUpdate',
          path: 'inventory-returns/:id/update',
          component: InventoryBO.InventoryReturnCreate,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'returnCreate',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'returns',
                to: '/inventory-returns',
              },
            ],
          },
        },
        {
          name: 'TriggersTable',
          path: 'triggers',
          component: TriggersTable,
          meta: {
            requiresAuth: true,
            accessRight: 'isOctipasAdmin',
            breadcrumbs: {
              label: 'TriggersTable',
              reset: true,
            },
          },
        },
        {
          name: 'TriggersCreation',
          path: 'triggers/add',
          component: TriggerDetail,
          meta: {
            requiresAuth: true,
            accessRight: 'isOctipasAdmin',
            breadcrumbs: {
              label: 'TriggersCreation',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'TriggersTable',
                to: '/triggers',
              },
            ],
          },
        },
        {
          name: 'TriggersDetail',
          path: 'triggers/:id',
          component: TriggerDetail,
          meta: {
            requiresAuth: true,
            accessRight: 'isOctipasAdmin',
            breadcrumbs: {
              label: 'TriggersDetail',
              reset: false,
            },
            parentBreadcrumbs: [
              {
                label: 'TriggersTable',
                to: '/triggers',
              },
            ],
          },
        },
        {
          name: 'TriggersSettingsDetails',
          path: 'triggers-settings',
          component: TriggerSettings,
          meta: {
            requiresAuth: true,
            accessRight: 'isOctipasAdmin',
            breadcrumbs: {
              label: 'triggersSettings',
              reset: true,
            },
          },
        },
        {
          name: 'TriggersHistoriesTable',
          path: 'triggers-histories',
          component: TriggersHistoriesTable,
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'executionsHistoryTable',
              reset: true,
            },
          },
        },
        {
          name: 'TriggerHistoryDetails',
          path: 'triggers-histories/:id',
          component: TriggerHistoryDetails,
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'triggerHistoryDetails',
              reset: true,
            },
            parentBreadcrumbs: [
              {
                label: 'executionsHistoryTable',
                to: '/triggers-histories',
              },
            ],
          },
        },
        {
          name: 'EbookingsCustomizationsTable',
          component: EbookingsCustomizationsTable,
          path: 'customizations/ebookings',
          meta: { requiresAuth: true, accessRight: 'isAdmin' },
        },
        {
          name: 'EbookingsCustomization',
          component: EbookingsCustomization,
          path: 'customizations/ebookings/:id',
          meta: { requiresAuth: true, accessRight: 'isAdmin' },
        },
        {
          name: 'carriers',
          path: 'carriers',
          component: CarriersTable,
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'carriers',
              reset: true,
            },
          },
        },
        {
          name: 'carriersDetails',
          path: 'carriers/add',
          props: true,
          component: CarriersDetails,
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            parentBreadcrumbs: [
              {
                label: 'carriers',
                to: '/carriers',
              },
            ],
          },
        },
        {
          name: 'deliveryMethod',
          path: 'delivery-methods',
          component: DeliveryTable,
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'deliveryMethods',
              reset: true,
            },
          },
        },
        {
          name: 'deliveryMethodAdd',
          path: 'delivery-methods/add',
          props: true,
          component: DeliveryDetails,
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'addDeliveryMethod',
              reset: true,
            },
            parentBreadcrumbs: [
              {
                label: 'deliveryMethods',
                to: '/delivery-methods',
              },
            ],
          },
        },
        {
          name: 'deliveryMethodDetails',
          path: 'delivery-methods/:id',
          props: true,
          component: DeliveryDetails,
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'deliveryMethod',
              reset: true,
            },
            parentBreadcrumbs: [
              {
                label: 'deliveryMethods',
                to: '/delivery-methods',
              },
            ],
          },
        },
        {
          name: 'FindInStoreSettingsTable',
          component: FindInStoreSettingsTable,
          path: '/find-in-store-settings',
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'findInStoreSettingsTable',
              reset: true,
            },
          },
        },
        {
          name: 'FindInStoreSettings',
          component: FindInStoreSettings,
          path: '/find-in-store-settings/:id',
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'findInStoreSettings',
              reset: true,
            },
            parentBreadcrumbs: [
              {
                label: 'findInStoreSettingsTable',
                to: '/find-in-store-settings',
              },
            ],
          },
        },
        {
          name: 'FindInStoreSettingsAdd',
          component: FindInStoreSettings,
          path: '/find-in-store-settings/add',
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'addFindInStoreSettings',
              reset: true,
            },
            parentBreadcrumbs: [
              {
                label: 'findInStoreSettingsTable',
                to: '/find-in-store-settings',
              },
            ],
          },
        },
        {
          name: 'lists',
          path: 'lists',
          component: listsTable,
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'lists',
              reset: true,
            },
          },
        },
        {
          name: 'listAdd',
          path: 'lists/add',
          component: listDetails,
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'newList',
              reset: true,
            },
            parentBreadcrumbs: [
              {
                label: 'lists',
                to: '/lists',
              },
            ],
          },
        },
        {
          name: 'listDetail',
          path: 'lists/:id',
          component: listDetails,
          meta: {
            requiresAuth: true,
            accessRight: 'isAdmin',
            breadcrumbs: {
              label: 'list',
              reset: true,
            },
            parentBreadcrumbs: [
              {
                label: 'lists',
                to: '/lists',
              },
            ],
          },
        },
        {
          name: 'BinSummary',
          path: '/bins/new',
          component: BinSummary,
          props: true,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'binPreparation',
              reset: true,
            },
          },
        },
        {
          name: 'BinSummary',
          path: '/bins/:id',
          component: BinSummary,
          props: true,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'binPreparation',
              reset: true,
            },
          },
        },
        {
          name: 'BinSummaryTable',
          path: '/bins',
          component: PickPackShipsTable,
          props: true,
          meta: {
            requiresAuth: true,
            breadcrumbs: {
              label: 'binPreparations',
              reset: true,
            },
          },
        },
      ],
    },
    {
      name: 'callback',
      path: '/callback',
      component: Callback,
    },
    {
      name: 'errors',
      path: '/errors',
      component: Errors,
      props: true,
    },
  ],
  mode: 'history',
})

// Gate the central Refunds page on display.refund_menu_roles from the returns settings,
// mirroring NavigationDrawer.refundMenuAllowed so a direct URL hit can't bypass the menu.
// Secure-by-default: empty/absent roles (or a failed fetch) deny access.
// Whether the refunds feature is enabled for the current user: octipas-admin always,
// otherwise the role must be in the tenant's display.refund_menu_roles (RTLOMS-540).
async function refundFeatureAllowed() {
  const roles = store.state.roles
  if (!roles) {
    return false
  }
  if (store.state.isOctipasAdmin) {
    return true
  }
  try {
    const service = new ReturnSettingsService(router.app.$auth)
    const countryIso3 = store.state.currentStoreDetails?.address?.country_id
    const settings = await service.getReturnSettings(countryIso3)
    const allowedRoles = settings?.display?.refund_menu_roles
    return Array.isArray(allowedRoles) && roles.some((role) => allowedRoles.includes(role))
  } catch (e) {
    console.error(e)
    return false
  }
}

// Central refunds view: feature enabled AND a customer-service/admin role. The view is
// NOT store-scoped, so store-only roles must not reach it (they would see every store).
async function refundCentralGuard(to, from, next) {
  if ((await refundFeatureAllowed()) && (store.state.isCustomerService || store.state.isOctipasAdmin)) {
    return next()
  }
  return next({ name: 'waitingOrders' })
}

// Refund feature gate (no audience restriction): used by the store list and the refund detail,
// both reachable by central and store users. Store/detail data scoping is enforced server-side.
async function refundFeatureGuard(to, from, next) {
  if (await refundFeatureAllowed()) {
    return next()
  }
  return next({ name: 'waitingOrders' })
}

// Documents list: the tenant configuration decides who sees the menu, so the route asks the same
// question the drawer asks. An octipas-admin passes regardless. A 5xx or a timeout is not a refusal —
// fail closed, but say so, or the redirect reads as lost access.
async function documentMenuGuard(to, from, next) {
  if (store.state.isOctipasAdmin) {
    return next()
  }
  try {
    let settings = store.state.documentSettings
    if (!settings) {
      // Fills the cache it reads: a drawer load that failed at boot repairs itself here, instead of
      // leaving the menu entry hidden for the rest of the session.
      settings = await new DocumentSettingsService(router.app.$auth).getSettings()
      store.commit('setDocumentSettings', settings)
    }
    if (documentMenuAllowed(settings, store.state.roles)) {
      return next()
    }
  } catch (error) {
    if (error.response?.status !== 403) {
      EventBus.$emit('displaySnackbar', {
        display: true,
        text: router.app.$t('documentDisplay.accessCheckError'),
        color: 'error',
      })
    }
  }
  return next({ name: 'waitingOrders' })
}

router.beforeEach(async (to, from, next) => {
  store.dispatch('setPreviousPath', from.path)
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (await router.app.$auth.isAuthenticated()) {
      if (!store.state.roles) {
        await router.replace({ name: 'errors', params: { error: 'notAuthorized', displayLogoutBtn: true } })
      } else if (to.meta.accessRight) {
        if (store.state[to.meta.accessRight]) {
          next()
        } else {
          await router.push({ name: 'waitingOrders' })
        }
      } else {
        next()
      }
    } else {
      return router.app.$auth.login()
    }
  } else {
    next()
  }
})

export default router
